"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageGuidelineDialog = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const manage_guideline_dialog_form_constants_1 = require("./manage-guideline-dialog-form.constants");
const manage_guideline_dialog_styles_1 = require("./manage-guideline-dialog.styles");
const validation_schema_1 = require("./validation-schema");
const hooks_1 = require("../../client/hooks");
const product_tree_node_1 = require("../../client/product-tree-node");
const components_1 = require("../../components");
const global_tree_edit_warning_1 = require("../../components/global-tree-edit-warning");
const generic_1 = require("../../generic");
const hooks_2 = require("../../hooks");
const hooks_3 = require("../../../hooks");
const localization_1 = require("../../../localization");
const store_1 = require("../../../store");
const ManageGuidelineDialog = ({ isReadOnly, productTreeNode, onActionCompleted, onClose, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { addSuccess, addError } = (0, hooks_3.useNotification)();
    const shouldShowGlobalTreeEditWarning = (0, store_1.useShouldShowGlobalTreeEditWarning)();
    const { refetchProductTreeNodes } = (0, hooks_1.useRefetchQueries)();
    const validationSchema = (0, validation_schema_1.useManageStrategyNodeGuidelineValidationSchema)();
    const { id, title, description } = productTreeNode !== null && productTreeNode !== void 0 ? productTreeNode : {};
    const { editProductTree, error } = (0, product_tree_node_1.useEditProductTreeNode)();
    const { getTreeNodeDisplayNameByTitle } = (0, hooks_2.useTreeNodeDisplayName)();
    const { onGlobalTreeReplacement } = (0, global_tree_edit_warning_1.useGlobalTreeEditWarning)(productTreeNode === null || productTreeNode === void 0 ? void 0 : productTreeNode.id);
    const handleTreeReplacement = (isGlobalStrategyReplacementAccepted) => __awaiter(void 0, void 0, void 0, function* () {
        const isTreeReplacementNeeded = shouldShowGlobalTreeEditWarning && isGlobalStrategyReplacementAccepted;
        if (!isTreeReplacementNeeded) {
            return id;
        }
        const { targetNodeId } = yield onGlobalTreeReplacement();
        if (!targetNodeId) {
            throw new Error('Target node is not found');
        }
        return targetNodeId;
    });
    const handleFormSubmit = (_a) => __awaiter(void 0, [_a], void 0, function* ({ description: newDescription, isGlobalStrategyReplacementAccepted }) {
        try {
            const newTargetNodeId = yield handleTreeReplacement(Boolean(isGlobalStrategyReplacementAccepted));
            if (!newTargetNodeId) {
                throw new Error('Target node is not found');
            }
            void editProductTree({
                variables: { productTreeNode: { id: newTargetNodeId, data: { description: newDescription }, clientMutationId: '' } },
                onCompleted: () => {
                    addSuccess(t({ key: 'EDIT_GUIDELINE_SUCCESS' }));
                    onActionCompleted(() => refetchProductTreeNodes([newTargetNodeId]));
                    onClose();
                },
                onError: (error) => {
                    throw new Error(error.message);
                },
            });
        }
        catch (e) {
            addError(t({ key: 'EDIT_GUIDELINE_ERROR' }), e.message);
        }
    });
    const initialValues = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, manage_guideline_dialog_form_constants_1.manageGuidelineFormInitialValues), { [manage_guideline_dialog_form_constants_1.ManageGuidelineFormFieldNames.NodeName]: getTreeNodeDisplayNameByTitle(title), [manage_guideline_dialog_form_constants_1.ManageGuidelineFormFieldNames.Guideline]: description !== null && description !== void 0 ? description : '' })), [title, description, getTreeNodeDisplayNameByTitle]);
    return (react_1.default.createElement(ui_components_1.Form, { enableReinitialize: true, validateOnBlur: true, initialValues: initialValues, validationSchema: validationSchema, handleSubmit: handleFormSubmit }, ({ isSubmitting, isValid, dirty, values, handleSubmit, setFieldValue, }) => (react_1.default.createElement(manage_guideline_dialog_styles_1.StyledActionDialog, { open: true, fullWidth: true, maxWidth: "md", title: t({ key: 'STRATEGY_GUIDELINE_DIALOG_TITLE', values: { nodeName: title } }), proceedButtonProps: {
            title: t({ key: 'ACTION_SAVE' }),
            onClick: () => handleSubmit(),
            disabled: isReadOnly || !isValid || !dirty || isSubmitting,
            endIcon: isSubmitting && react_1.default.createElement(generic_1.LoadingIndicator, null),
        }, cancelButtonProps: {
            title: t({ key: 'CANCEL' }),
            onClick: onClose,
        } }, react_1.default.createElement(generic_1.ActionDialogContainer, null, react_1.default.createElement(generic_1.ActionDialogContent, null, react_1.default.createElement(manage_guideline_dialog_styles_1.StyledFormListItem, null, react_1.default.createElement(ui_components_1.TextFormField, { disabled: true, name: manage_guideline_dialog_form_constants_1.ManageGuidelineFormFieldNames.NodeName, className: "list-item-node-name", size: "small", variant: "outlined" }), react_1.default.createElement(ui_components_1.TextFormField, { disabled: isReadOnly, name: manage_guideline_dialog_form_constants_1.ManageGuidelineFormFieldNames.Guideline, multiline: true, fullWidth: true, maxRows: 4, placeholder: t({ key: 'STRATEGY_GUIDELINE_DIALOG_GUIDELINE_PLACEHOLDER' }), className: "list-item-textarea", variant: "outlined", size: "small" })), error && react_1.default.createElement(components_1.Alert, { severity: 'error' }, error.message)), shouldShowGlobalTreeEditWarning && (react_1.default.createElement(global_tree_edit_warning_1.GlobalTreeEditWarning, { isChecked: Boolean(values[global_tree_edit_warning_1.GlobalTreeEditWarningFormFieldNames.isGlobalStrategyReplacementAccepted]), onChange: (value) => setFieldValue(global_tree_edit_warning_1.GlobalTreeEditWarningFormFieldNames.isGlobalStrategyReplacementAccepted, value, true) })))))));
};
exports.ManageGuidelineDialog = ManageGuidelineDialog;
exports.default = exports.ManageGuidelineDialog;
